import { Redirect, RouteComponentProps } from 'react-router-dom';

//The notification settings live in a modal of the NavBar settings panel, not on a route. The mail
//footer links to /settings/notifications, which redirects to the dashboard with a marker parameter
//that SettingsNavItem consumes. The whole query string is carried over, so tid and ouid survive.
const dashboardDeepLinkPath = '/dashboard/me';

export const notificationSettingsQueryParam = 'notificationSettings';

export const hasNotificationSettingsQuery = (search: string): boolean => {
  return new URLSearchParams(search).get(notificationSettingsQueryParam) === '1';
};

export const clearNotificationSettingsQueryParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(notificationSettingsQueryParam);
  const search = searchParams.toString();
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`,
  );
};

const NotificationSettingsDeepLink = (props: RouteComponentProps) => {
  const searchParams = new URLSearchParams(props.location.search);
  searchParams.set(notificationSettingsQueryParam, '1');

  return <Redirect to={{ pathname: dashboardDeepLinkPath, search: searchParams.toString() }} />;
};

export default NotificationSettingsDeepLink;
